import { UndefinedAble } from 'data/base';

export function lastOrUndefined<T>(source: T[]): UndefinedAble<T> {
  if (source.length > 0) {
    return source[source.length - 1];
  } else {
    return undefined;
  }
}

export function firstOrUndefined<T>(source: T[]): UndefinedAble<T> {
  if (source.length > 0) {
    return source[0];
  } else {
    return undefined;
  }
}
